import Typography from "@mui/material/Typography";
import React from "react";

const H1Header = ({ children }) => (
  <Typography
    component="h1"
    variant="h1"
    align="center"
    color="primary.contrastText"
    paragraph
    gutterBottom
    sx={{
      my: 0,
      fontSize: { xs: '2rem', sm: '2.4rem', md: '2.8rem', lg: '3.2rem' },
    }}
  >
    {children}
  </Typography>
);

export default H1Header;